/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L7_Price_P2_AfterInputs */

const es_l7_price_p2_after = /** @type {(inputs: L7_Price_P2_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` es la pequeña tasa oficial del cambio de uso, que cobra la administración, no nosotros.`)
};

const gl_l7_price_p2_after = /** @type {(inputs: L7_Price_P2_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` é a pequena tasa oficial do cambio de uso, que cobra a administración, non nós.`)
};

const en_l7_price_p2_after = /** @type {(inputs: L7_Price_P2_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` is the small official change-of-use fee, charged by the authorities, not us.`)
};

/**
* | output |
* | --- |
* | "is the small official change-of-use fee, charged by the authorities, not us." |
*
* @param {L7_Price_P2_AfterInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l7_price_p2_after = /** @type {((inputs?: L7_Price_P2_AfterInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L7_Price_P2_AfterInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l7_price_p2_after(inputs)
	if (locale === "en") return en_l7_price_p2_after(inputs)
	return es_l7_price_p2_after(inputs)
});